import fetch from 'isomorphic-fetch'
// import commonTableData from './jsonData/commonTable.json'


export const REQUEST_DATA = 'REQUEST_DATA'
export const RECEIVE_DATA = 'RECEIVE_DATA'
export const SET_TRANSITION = 'SET_TRANSITION'
export const SET_HASH_URL = 'SET_HASH_URL'
export const SET_JUMP_MODE = 'SET_JUMP_MODE'

const requestData = () => ({
    type:REQUEST_DATA
})

const receiveData = (data,columns,pagination) => ({
    type:RECEIVE_DATA,
    data,
    columns,
    pagination
})


export const getCommonTableDataByPage = (url,pageSize=5,current=1,columns) => {
    return dispatch => {
        if(commonTableData){
            let data = commonTableData.data;
            let pagination = {total:commonTableData.total,current:current,pageSize:pageSize}
            dispatch(requestData());
            dispatch(receiveData(data,columns,pagination));
        }

    }
}


export const setHashUrl = (hashUrl) => {

    return {
        type:SET_HASH_URL,
        data:hashUrl
    }
}

export const setTransition = (transiton) => {

    return {
        type:SET_TRANSITION,
        data:transiton
    }
}

export const setJumpMode = (jumpMode) => {
    return {
        type:SET_JUMP_MODE,
        data:transiton
    }
}


// WEBPACK FOOTER //
// ./actions.js